'use client';

import Link from 'next/link';
import useSWR from 'swr';
import { cn } from '@/lib/utils';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet';
import { ScrollArea } from '@/components/ui/scroll-area';

const Sidebar = () => {
  const { data: categories, error, isLoading } = useSWR('/api/products/categories');

  if (error) return <p className="text-red-500">Failed to load categories.</p>;
  if (isLoading || !categories) return <p>Loading categories...</p>;

  const commonLinks = [
    { name: 'Home', href: '/' },
    { name: 'About Us', href: '/about' },
    { name: 'Contact Us', href: '/contact' },
    { name: 'Policies', href: '/policies' },
    { name: 'Certificates', href: '/certificates' },
  ];

  return (
    <Sheet>
      <SheetTrigger asChild>
        <button
          aria-label="Open Sidebar"
          className="p-2 text-white bg-blue-600 rounded-md shadow hover:bg-blue-700"
        >
          ☰ Menu
        </button>
      </SheetTrigger>
      <SheetContent className="w-80">
        <SheetHeader>
          <SheetTitle className="text-lg font-semibold">Navigation</SheetTitle>
        </SheetHeader>
        <ScrollArea className="mt-4 h-[calc(100vh-10rem)]">
          <ul className="space-y-2">
            {/* Common Navigation Links */}
            {commonLinks.map((link) => (
              <li key={link.name}>
                <Link
                  href={link.href}
                  className={cn(
                    'flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-md'
                  )}
                >
                  {link.name}
                </Link>
              </li>
            ))}

            {/* Categories Section */}
            <li>
              <h2 className="mt-6 px-4 text-sm font-semibold uppercase text-gray-600">
                Shop Categories
              </h2>
              <ul className="mt-2 space-y-1">
                {categories.map((category: string) => (
                  <li key={category}>
                    <Link
                      href={`/search?type=${category}`}
                      className={cn(
                        'block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md'
                      )}
                    >
                      {category}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
          </ul>
        </ScrollArea>
      </SheetContent>
    </Sheet>
  );
};

export default Sidebar;
